import buttons from "./buttons";

const error_codes = {
	/* --------------------------- BACK OFFICE RELATED -------------------------- */
	BACK_OFFICE_DEBTOR_GROUP_MEMBER_EXISTS: "This debtor already exists within this debtor group.",

	// READ
	DADUP_ERR_1_NOT_FOUND: "Dadup not found",

	/* ------------------------------ DADUP RELATED ----------------------------- */
	// CREATE
	DADUP_ERR_2_COULD_NOT_CREATE_DADUP: "Dadup cannot be created, please contact us.",

	DADUP_ERR_2_INVALID_DADUP_NAME: "This name is not permitted for your daDup account.",

	// DELETE
	DADUP_ERR_3_CANNOT_DELETE_WITH_BUCKETS:
		"Dadup account cannot be deleted if there are still buckets on the account.",

	DADUP_ERR_3_COULD_NOT_CREATE_BUCKET: "Bucket could not be created, please contact support.",

	DADUP_ERR_4_INVALID_BUCKET_NAME: "This name is not permitted for your bucket.",

	DADUP_ERR_5_BUCKET_NAME_ALREADY_EXISTS:
		"There is already a bucket with this name under one of your daDup accounts.",

	DADUP_ERR_8_COULD_NOT_READ_DADUP: "Could not read daDup. Please contact support.",

	DADUP_ERR_9_HISTORY_USAGE_ERROR: "Could not read the consumption of your buckets",

	DADUP_ERR_10_REQUEST_ACCESS_TOKEN_ERROR: "Could not retrieve your credentials",

	DADUP_ERR_11_COULD_NOT_READ_BUCKET: "Could not read your bucket(s)",

	// Update
	DADUP_ERR_12_COULD_NOT_UPDATE_DADUP: "Could not update daDup.",

	DADUP_ERR_13_CREDENTIALS_SAVED_ERROR: "Could not save that you have saved the data.",

	DADUP_ERR_14_CANNOT_DELETE_WITH_BUCKETS:
		"The daDup account could not be deleted because there were still buckets present. Please delete all buckets first.",

	DADUP_ERR_15_COULD_NOT_DELETE_DADUP:
		"Could not delete your daDup account, please contact support",

	DADUP_ERR_16_COULD_NOT_UPDATE_BUCKET: "Could not update your bucket.",

	DADUP_ERR_17_COULD_NOT_DELETE_BUCKET: "Could not delete your bucket, please contact support.",

	//GENERAL / OTHER
	DADUP_ERR_18_COULD_NOT_SEND_DADUP_NOTIFICATION: "Could not send a notification.",

	DADUP_ERR_19_COULD_NOT_HANDLE_DADUP_REQUEST:
		"Something went wrong while processing your daDup request. Please contact support.",

	DADUP_ERR_20_COULD_NOT_HANDLE_BUCKET_REQUEST:
		"Something went wrong while processing your bucket request. Please contact support.",

	DADUP_ERR_21_COULD_NOT_UPDATE_DESCRIPTION:
		"An error occurred while updating the description. Please try again later.",

	/* ----------------------------- DEBTOR RELATED ----------------------------- */
	DEBTOR_ERR_1_PAID_SERVICES_DISABLED:
		"Paid services are not available for your account. If you think this is incorrect, please contact our customer service team.",

	DEBTOR_ERR_2_DEBTOR_NOT_FOUND:
		"The debtor has not been found. If this is not correct, please contact our customer service department if this problem persists.",

	DEBTOR_ERR_4_DEBTOR_DISABLED_IN_COUNTRY: "Registration is not permitted from your country.",
	DEBTOR_ERR_5_FREELOADER_DISABLED_IN_COUNTRY:
		"Registrations for private users are not permitted from your country.",

	DEBTOR_ERR_6_COMPANY_DETAILS_IDENTICAL_TO_TUXIS:
		"Your VAT number and/or Chamber of Commerce number is identical to Tuxis. This is not permitted.",
	DEBTOR_ERR_7_VIES_COUNTRY_CODE_NOT_MATCHING:
		"The VAT number you entered does not match the country you selected.",
	DEBTOR_ERR_8_VIES_INVALID_NUMBER: "The VAT number you entered appears to be incorrect.",
	DEBTOR_ERR_9_VIES_COMMUNICATION_ERROR: `An error occurred with VIES (VAT Information Exchange System) while checking the VAT number. Tuxis has been notified and will contact you so that your account can still be created. You can always try again by clicking "${buttons.sign_up}" or re-register at a later time.`,
	DEBTOR_ERR_10_EMAIL_ADDRESS_NOT_EXISTS: "The email address you entered does not appear to exist.",

	/* ------------------------------- DNS RELATED ------------------------------ */
	DNS_ERR_1_DNS_TEMPLATE_NOT_FOUND: "DNS template not found, check the existence of this template.",

	DNS_ERR_2_FAILED_TO_READ_FROM_POWERDNS:
		"Something went wrong while retrieving information from PowerDNS. Please contact our customer service team if this problem persists.",

	DNS_ERR_3_FAILED_TO_WRITE_TO_POWERDNS:
		"Something went wrong while saving to PowerDNS. Please check the values or contact our customer service if this problem persists.",

	DNS_ERR_4_FAILED_TO_DELETE_FROM_POWERDNS:
		"Something went wrong while deleting from PowerDNS. Please contact our customer support team if this problem persists.",

	DNS_ERR_5_MULTIPLE_ENTRIES_NOT_ALLOWED:
		"Multiple lines with the same label are not allowed for some records, please modify them.",

	DNS_ERR_6_DOMAIN_1: "",

	DNS_ERR_7_A_1: "An A record needs a valid IPv4 address as value.",

	DNS_ERR_8_AAAA_1: "An AAAA record needs a valid IPv6 address as value.",

	DNS_ERR_9_ALIAS_1: "",

	DNS_ERR_10_CAA_1: "",

	DNS_ERR_11_CNAME_1: "A CNAME record cannot have @ as label.",

	DNS_ERR_12_CNAME_2:
		"A CNAME record needs a valid domain name as value and needs to end on a period.",

	DNS_ERR_13_CNAME_3: "A CNAME record cannot have multiple entries for the same label.",

	DNS_ERR_14_CNAME_4: "A CNAME record cannot have the same label as an A or AAAA record.",

	DNS_ERR_15_MX_1: "A MX record needs a valid domain name as value and needs to end on a period.",

	DNS_ERR_16_LABEL_1: "Invalid label.",

	DNS_ERR_17_NS_1: "A NS record cannot have @ as label.",

	DNS_ERR_18_NS_2: "A NS record needs a valid domain name as value and needs to end on a period.",

	DNS_ERR_19_NONE_1: "Invalid DNS record type.",

	DNS_ERR_20_PTR_1: "",

	DNS_ERR_21_URI_1: "",

	DNS_ERR_22_SOA_1: "",

	DNS_ERR_23_SPF_1: "",

	DNS_ERR_24_SRV_1: "Invalid label for SRV record.",

	DNS_ERR_25_SRV_2: "Invalid value for SRV record.",

	DNS_ERR_26_TLSA_1: "",

	DNS_ERR_27_TXT_1: "",

	DNS_ERR_28_FAILED_TO_DELETE_DNS_ZONE:
		"A problem occurred while deleting the domain's DNS zone. Please contact our customer service department.",

	DNS_ERR_29_DNSSEC_KEY_INVALID_ALGORITHM:
		"An error occurred with our third party while creating the DNSSEC key. Please contact our customer service team.",

	DNS_ERR_30_OXXA_ADD_DNSSEC_ITEMS_FAILED:
		"An error occurred with our third party while activating DNSSEC for this domain. Please contact our customer service team.",

	DNS_ERR_31_OXXA_DELETE_DNSSEC_ITEM_FAILED:
		"An error occurred with our third party while removing DNSSEC for this domain. Please contact our customer service team.",

	DNS_ERR_32_POWERDNS_ADD_DNSSEC_ITEMS_FAILED:
		"An error occurred with our third party while activating DNSSEC for this domain. Please contact our customer service team.",

	DNS_ERR_33_POWERDNS_READ_DNSSEC_ITEMS_FAILED:
		"An error occurred with our third party while retrieving DNSSEC information for this domain. Please contact our customer service team.",

	DNS_ERR_34_POWERDNS_DELETE_DNSSEC_ITEMS_FAILED:
		"An error occurred with our third party while removing DNSSEC for this domain. Please contact our customer service team.",

	DNS_ERR_35_POWERDNS_NOT_ALLOWED_TO_READ_ZONE:
		"This debtor does not have permissions to read or write to this DNS zone. If this is not correct, please contact our customer service team.",

	DNS_ERR_36_PARSING_DNS_RECORDS_FAILED:
		"An error occurred while retrieving the DNS records. Please contact our customer service team if this problem persists.",

	DNS_ERR_37_SRV_3: "Weight and port numbers must be between 0 and 65535",

	DNS_ERR_38_FAILED_TO_UPDATE_DNS_RECORD_ITEM:
		"An error occurred while updating a DNS record rule. Please contact our customer service team if this problem persists.",

	/* ----------------------------- DOMAIN RELATED ----------------------------- */
	DOMAIN_ERR_1_DOMAIN_NOT_FOUND:
		"Domain not found. Please check if this domain exists and if you are owner of this domain.",

	DOMAIN_ERR_2_DOMAIN_ALREADY_CANCELLED:
		"Domain is already cancelled. You cannot cancel an already cancelled domain. Want to revert this? contact our customer-service.",

	DOMAIN_ERR_3_DOMAIN_STILL_ACTIVE_OR_AUTORENEW_IS_ON:
		"Domain is still active and/or autorenew is on, disable autorenew first.",

	DOMAIN_ERR_4_CANNOT_REVERSE_ACTION_ON_RENEWAL:
		"You cannot reverse the cancellation of a domain. Still want to revert this? contact our customer-service.",

	DOMAIN_ERR_5_PRODUCT_DOMAIN_NOT_FOUND:
		"Domain extension not found, If you are certain it should exist, contact our customer-service",

	DOMAIN_ERR_6_PRODUCT_DOMAIN_IN_USE:
		"Cannot create product domain as it exist already, use the already existing one.",

	DOMAIN_ERR_7_PRODUCT_DOMAIN_UNKNOWN_PRICE_COMMAND:
		"This command is not used to check the price of the domain extension, contact support or submit a feature request if you want this command to be added.",

	DOMAIN_ERR_8_EXTERNAL_PARTY_ERROR:
		"An error has occurred at our external party, this is most likely due to a missinput or their service is down.",

	DOMAIN_ERR_9_HOSTFACT_HANDLE_NOT_FOUND:
		"The hostfact handle was not found, please check if it exists. if it does, contact a developer.",

	DOMAIN_ERR_10_FAILED_CREATING_OXXA_IDENTITY:
		"Something went wrong while creating a oxxa identity, this is likely due to missinput or faulty relation details info.",

	DOMAIN_ERR_11_FAILED_IMPORTING_DOMAIN:
		"Something went wrong while importing a domain from hostfact. Please check all the information carefully and if the correct relation is selected. if the problem keeps happening, contact a developer.",

	DOMAIN_ERR_12_DOMAIN_HAS_NO_DOMAIN_RELATION_DETAILS:
		"This domain does not have any relation details, please add these or check if the details are set up correctly.",

	DOMAIN_ERR_13_NO_SIMILAR_RELATIONS_FOUND: "Something went wrong while comparing relations.",

	DOMAIN_ERR_14_QUEUE_INVALID_DOMAIN_STATUS:
		"The selected domain has a status that cannot use the action you selected. Please check if you are updating the correct domain or refresh the page for up-to-date domain statuses.",

	DOMAIN_ERR_15_NS_GROUP_NOT_FOUND: "Ns group was not found for this domain.",

	DOMAIN_ERR_16_DEBTOR_ALREADY_USING_CUSTOM_NS_GROUP:
		"Your account is already using custom NS group.",

	DOMAIN_ERR_17_NS_GROUP_NOT_ON_THIS_DOMAIN:
		"Ns group is not an option on this domain or not available.",

	DOMAIN_ERR_18_FATAL_ERROR_WHILE_FETCHING_NS_GROUP:
		"A fatal error occurred while fetching NS group, please try again or contact our customer service.",

	DOMAIN_ERR_19_DOMAIN_NOT_RELATED_TO_ACCOUNT:
		"Domain is not related to this account. Please check if you are in possession of this domain.",

	DOMAIN_ERR_20_TLD_DOES_NOT_USER_EPP: "This domain extension does not support transfers.",

	DOMAIN_ERR_21_PRODUCT_DOMAIN_LOCKED_GROUP:
		"You cannot remove products from a locked product group",

	DOMAIN_ERR_22_PRODUCT_DOMAIN_NOT_PRESENT_IN_GROUP:
		"This product is not present in the group, please add it first.",

	DOMAIN_ERR_23_PRODUCT_DOMAIN_ALREADY_PRESENT_IN_GROUP:
		"This product is already present in the group.",

	DOMAIN_ERR_24_TLD_ACTION_NOT_ENABLED:
		"A problem has occurred due to an unauthorized action of a domain extension. Please contact our customer service team.",

	DOMAIN_ERR_25_DOMAIN_NAME_TOO_SHORT_FOR_EXTENSION:
		"The domain name for this domain extension is too short. Create a domain name with a higher number of characters.",

	DOMAIN_ERR_26_DOMAIN_NAME_TOO_LONG_FOR_EXTENSION:
		"The domain name for this domain extension is too long. Please create a domain name with a lower number of characters.",

	DOMAIN_ERR_27_EXTENSION_DOES_NOT_ALLOW_NUMERIC_ONLY_DOMAIN_NAME:
		"This domain extension does not support a domain name with numbers only. However, numbers are supported when there is at least one letter in the name.",

	DOMAIN_ERR_28_FAILED_UPDATING_OXXA_IDENTITY:
		"An error has occurred with our third party. Please contact our customer service.",

	DOMAIN_ERR_29_FAILED_DELETING_OXXA_IDENTITY:
		"An error has occurred with our third party. Please contact our customer service.",

	DOMAIN_ERR_30_FAILED_UPDATING_DOMAIN:
		"A problem occurred with our third party while updating the domain. Please contact our customer service team if this problem persists.",

	DOMAIN_ERR_31_PRODUCT_DOMAIN_REQUIRES_EPP_CODE_FOR_EDIT_DOMAIN:
		"This domain needs a move code to edit the domain.",

	DOMAIN_ERR_32_FAILED_TO_READ_DOMAIN_PURCHASE_INFO:
		"An error occurred while reading the details of this domain. Please contact our customer service team if this problem persists.",

	DOMAIN_ERR_35_FAILED_PARSING_ADDRESS_FROM_HOSTFACT:
		"The address from Hostfact cannot be split into the street name, house number and house number suffix. Please contact the developers",

	DOMAIN_ERR_37_TRANSFER_NOT_AVAILABLE_AT_THE_MOMENT:
		"Transferring any of these domain names is not possible at this time. Please contact our customer service team if this problem persists.",
	/* ---------------------------------- BASE ---------------------------------- */
	error_code: "Error Code",
	error_msg: "Error Message",

	/* ------------------------------ ORDER RELATED ----------------------------- */
	ORDER_ERR_1_ORDER_NOT_FOUND: "",

	ORDER_ERR_2_ERROR_DURING_PRICE_CALCULATION:
		"An error occurred while calculating the price of a product on the order. Please contact our customer service department.",

	/* ------------------------------- PBS RELATED ------------------------------ */
	PBS_ERR_1_NOT_A_RESELLER:
		"Your account does not have reseller status, therefore you cannot request PBS in reseller mode.",
	PBS_ERR_2_DATASTORE_NAME_NOT_UNIQUE:
		"You already have a datastore with the same name. Your datastore name must be unique.",
	PBS_ERR_3_FREE_ALREADY_ENABLED:
		"It is not possible to order more than one free version of PBS per customer.",
	PBS_ERR_4_DEBTOR_NOT_ALLOWED_ON_LOCATION:
		"It is not possible to request a PBS at the selected location. Please select another location or contact our customer service department.",
	PBS_ERR_5_ERROR_EMAIL_ADDRESS_REQUIRED:
		"An e-mail address is required to receive error messages. This can be set on the previous page.",
	PBS_ERR_6_LOCATION_HAS_NO_DEFAULT_NODE:
		"Currently we cannot find a suitable server at the selected location to deploy a new PBS on. Please contact our customer service team if this problem persists.",
	PBS_ERR_7_USER_REGISTRATION_FAILED:
		"An error occurred while registering a new user at the PBS site. If this problem persists, please contact our customer service team.",
	PBS_ERR_8_FAILED_TO_CREATE_ZFS_DATASTORE:
		"An error occurred while creating a new ZFS datastore. If this problem persists, please contact our customer service team.",
	PBS_ERR_9_FAILED_TO_CREATE_PBS_DATASTORE:
		"An error occurred while creating a new PBS datastore. If this problem persists, please contact our customer service team.",
	PBS_ERR_10_FAILED_TO_CREATE_PBS_USER_PERMISSIONS:
		"An error occurred when assigning permissions to the user to access the datastore. If this problem persists, please contact our customer service team.",
	PBS_ERR_11_NOT_FOUND: "The selected PBS was not found.",
	PBS_ERR_12_LIMIT_LOWER_THEN_CURRENT_USAGE:
		"The new datastore limit is lower than the current usage. Please increase the limit to continue.",
	PBS_ERR_13_RESELLER_RELATION_NOT_UPDATABLE:
		"You cannot change the relationship of a PBS when it is deployed for a customer (reseller mode).",
	PBS_ERR_14_CANCELLATION_ALREADY_PENDING: "This service (PBS) has already been cancelled.",
	PBS_ERR_15_CANCELLATION_NOT_PENDING:
		"The service has not been terminated, therefore it is not possible to cancel the termination.",
	PBS_ERR_16_LOCATION_NOT_FOUND: "The specified PBS location could not be found.",
	PBS_ERR_17_NODE_NOT_FOUND:
		"Currently, we cannot find a server at the selected location. Please contact our customer service if this issue persists.",
	PBS_ERR_18_FAILED_TO_CREATE_PBS_API_TOKEN:
		"A new API token cannot be created on the PBS node at this time. Please contact our customer support if this issue persists.",
	PBS_ERR_19_FAILED_TO_CREATE_PBS_API_TOKEN_PERMISSIONS:
		"PBS permissions cannot currently be added to the API token on the PBS node. Please contact our customer support if this issue persists.",

	/* -------------------------------- PBS SYNC -------------------------------- */
	PBS_SYNC_ERR_1_SYNC_FAILED_CREATE_REMOTE:
		"The remote host could not be created on the destination PBS node. Please contact our customer support if this issue persists.",
	PBS_SYNC_ERR_2_SYNC_FAILED_CREATE_SYNC_JOB:
		"A sync job could not be created on the destination PBS node. Please contact our customer support if this issue persists.",
	PBS_SYNC_ERR_3_SYNC_FAILED_CREATE_SYNC_IN_DATABASE:
		"The remote host could not be created in our database. Please contact our customer support if this issue persists.",
	PBS_SYNC_ERR_4_SYNC_FAILED_CREATE_FATAL_ERROR:
		"A PBS sync could not be created at this time. Please contact our customer support if this issue persists.",
	PBS_SYNC_ERR_5_COULD_NOT_READ_REMOTE: "The remote PBS cannot currently be read from Proxmox.",
	PBS_SYNC_ERR_6_COULD_NOT_READ_SYNC_JOB: "The sync job cannot currently be read from Proxmox.",
	PBS_SYNC_ERR_7_COULD_NOT_READ_SYNC_RECORD_FROM_DATABASE:
		"The sync job cannot currently be read from the database.",
	PBS_SYNC_ERR_8_SYNC_READ_SYNC_FATAL_ERROR:
		"An error occurred while retrieving sync information. Please contact our customer support if this issue persists.",
	PBS_SYNC_ERR_9_SYNC_FAILED_UPDATE_REMOTE:
		"The remote host could not be updated in Proxmox at this time.",
	PBS_SYNC_ERR_10_SYNC_FAILED_UPDATE_SYNC_JOB:
		"The sync job could not be updated in Proxmox at this time.",
	PBS_SYNC_ERR_11_SYNC_UPDATE_SYNC_IN_DATABASE:
		"The sync job could not be updated in the database at this time.",
	PBS_SYNC_ERR_12_SYNC_UPDATE_FATAL_ERROR:
		"The PBS sync could not be updated. Please contact our customer support if this issue persists.",
	PBS_SYNC_ERR_13_DELETE_REMOTE_ERROR: "The remote host could not be deleted from Proxmox.",
	PBS_SYNC_ERR_14_DELETE_SYNC_JOB_ERROR: "The sync job could not be deleted from Proxmox.",
	PBS_SYNC_ERR_15_DELETE_SYNC_FROM_DATABASE_ERROR:
		"The sync job could not be deleted from the database.",
	PBS_SYNC_ERR_16_DELETE_SYNC_FATAL_ERROR:
		"The sync information could not be deleted. Please contact our customer support if this issue persists.",
	PBS_SYNC_ERR_17_REMOTE_HOST_NAME_NOT_PROVIDED_OR_INVALID:
		"The remote host name was not provided or is invalid.",
	PBS_SYNC_ERR_18_REMOTE_HOST_PORT_NOT_PROVIDED_OR_INVALID:
		"The remote host port was not provided or is invalid.",
	PBS_SYNC_ERR_19_NO_SOURCE_PROVIDED_OR_INVALID:
		"No source provided. A sync job cannot be created without a source.",
	PBS_SYNC_ERR_20_REMOTE_API_USER_OR_TOKEN_MISSING_OR_INVALID:
		"The API user or token is missing or invalid.",
	PBS_SYNC_ERR_21_REMOTE_FINGERPRINT_REQUIRED_OR_INVALID:
		"The fingerprint is required when the host uses a self-signed certificate.",
	PBS_SYNC_ERR_22_SYNC_PBS_ID_NOT_PROVIDED:
		"The PBS ID was not provided. This is required when the source PBS is hosted by Tuxis.",
	PBS_SYNC_ERR_23_NO_SCHEDULE_PROVIDED_OR_INVALID:
		"No synchronization schedule provided or the interval is invalid.",
	PBS_SYNC_ERR_24_COULD_NOT_ESTABLISH_PAYLOAD:
		"The payload could not be established. Please contact our customer support if this issue persists.",
	PBS_SYNC_ERR_25_INVALID_FINGERPRINT:
		"The provided fingerprint is invalid. Please check your input.",
	PBS_SYNC_ERR_26_PUSH_METHOD_NOT_SUPPORTED_IN_THIS_PORTAL_VERSION:
		"The push method is not supported in this version of the portal.",
	PBS_SYNC_ERR_27_REMOTE_TEST_FAILED:
		"The connection test with the remote host failed. Please check the input.",
	PBS_SYNC_ERR_28_REMOTE_FETCH_DATASTORE_FAILED:
		"The datastore could not be fetched from the remote host. Please check that the name is correct and exists on the specified remote.",

	/* -------------------------- PRODUCT GROUP RELATED ------------------------- */
	PRODUCT_GROUP_ERR_1_PRODUCT_GROUP_NOT_FOUND: "Product group not found.",

	/* ---------------------------- RELATION RELATED ---------------------------- */

	RELATION_ERR_1_RELATION_NOT_FOUND: "Relation not found.",

	RELATION_ERR_2_RELATION_DETAILS_NOT_FOUND:
		"The relation details were not found on this relation.",

	RELATION_ERR_3_RELATION_CANT_BE_DELETED_HAS_DOMAINS_LINKED:
		"Relation and its details cannot not be deleted. there are domains associated with it.",

	RELATION_ERR_4_RELATION_CANT_BE_DELETED_HAS_ITEMS_LINKED:
		"Relation cannot not be deleted. there are items associated with it.",

	RELATION_ERR_5_CANNOT_UPDATE_RELATION:
		"Can't update relation, validate your input or contact one of our support staff.",

	RELATION_ERR_6_CANNOT_CREATE_RELATION:
		"Cannot create relation, validate your input or contact one of our support staff.",

	RELATION_ERR_7_RELATION_DOMAIN_DETAILS_ALREADY_EXIST:
		"An attempt was made to create new domain relation data for this relation, but the data already exists. Please contact our customer service team if the problem persists.",

	RELATION_ERR_8_COMPANY_COC_NUMBER_REQUIRED:
		'The "CoC number" is required for one of the linked domains. Please fill in this field and save the domain data for this relation again.',

	RELATION_ERR_9_COMPANY_VAT_NUMBER_REQUIRED:
		'The "VAT number" is required for one of the linked domains. Please fill in this field and save the domain data for this relation again.',

	RELATION_ERR_10_COMPANY_TRADEMARK_COUNTRY_REQUIRED:
		'The "Trademark country" is required for one of the linked domains. Please fill in this field and save the domain data for this relation again.',

	RELATION_ERR_11_COMPANY_TRADEMARK_NAME_REQUIRED:
		'The "Trademark name" is required for one of the linked domains. Please fill in this field and save the domain data for this relation again.',

	RELATION_ERR_12_COMPANY_TRADEMARK_NUMBER_REQUIRED:
		'The "Trademark number" is required for one of the linked domains. Please fill in this field and save the domain data for this relation again.',

	RELATION_ERR_13_PERSON_ID_NUMBER_REQUIRED:
		'The "Identification Number" is required for one of the linked domains. Please fill in this field and save the domain data for this relation again.',

	RELATION_ERR_14_PERSON_ID_ISSUE_DATE_REQUIRED:
		'The "Identification Issue Date" is required for one of the linked domains. Please fill in this field and save the domain data for this relation again.',

	RELATION_ERR_15_PERSON_ID_ISSUER_REQUIRED:
		'The "Identification Issuer" is required for one of the linked domains. Please fill in this field and save the domain data for this relation again.',

	RELATION_ERR_16_PERSON_BIRTH_DATE_REQUIRED:
		'The "Date of Birth" is required for one of the linked domains. Please fill in this field and save the domain data for this relation again.',

	RELATION_ERR_17_COUNTRY_OF_BIRTH_REQUIRED:
		'The "Country of Birth" is required for one of the linked domains. Please fill in this field and save the domain data for this relation again.',

	RELATION_ERR_18_CITY_OF_BIRTH_REQUIRED:
		'The "City of Birth" is required for one of the linked domains. Please fill in this field and save the domain data for this relation again.',

	RELATION_ERR_19_GIVEN_NAME_REQUIRED:
		'"First Name" and "Last Name" are required for one of the linked domains. Please fill in this field and save the domain data for this relation again.',

	RELATION_ERR_20_ZIP_CODE_REQUIRED:
		'The "Postal Code" is required for one of the linked domains. Please fill in this field and save the domain data for this relation again.',

	RELATION_ERR_21_COMPANY_NAME_REQUIRED:
		'The "Company Name" is required for one of the linked domains. Please fill in this field and save the domain data for this relation again.',

	/* ------------------------------ USER RELATED ------------------------------ */
	USER_ERR_1_NOT_ALLOWED_AS_NON_SUPERUSER: "You are not authorized to perform this action.",

	USER_ERR_2_USER_NOT_FOUND:
		"The user was not found. If this is not correct, please contact our customer service department.",

	USER_ERR_3_UPDATE_SEEN_HOMEPAGE_TUTORIAL_FAILED:
		"An error occurred when updating that you have seen the homepage tutorial.",

	USER_ERR_7_DUPLICATE_SSH_KEY:
		"The SSH public key you have entered already exists in your account.",
	/* ------------------------------- VPS RELATED ------------------------------ */
	VPS_ERR_1_UNKNOWN_DATACENTER:
		"The datacenter you selected cannot be chosen for deploying new VPS.",
	VPS_ERR_2_TEMPLATE_NOT_FOUND:
		"The operating system or template you selected could not be found on our server.",
	VPS_ERR_3_TEMPLATE_BACKUP_NOT_FOUND:
		"The operating system or template you selected has no backup on our server. Therefore, it is not possible to deploy the VPS at this time.",
	VPS_ERR_4_TEMPLATE_CONFIG_NOT_FOUND:
		"At the moment, we cannot retrieve the configuration for the operating system or template you selected.",
	VPS_ERR_5_INSUFFICIENT_CORES:
		"The configuration you chose has fewer CPU cores than required by the operating system or template you selected.",
	VPS_ERR_6_TOO_MANY_CORES:
		"The configuration you chose has more CPU cores than allowed by the permitted limit.",
	VPS_ERR_7_INSUFFICIENT_MEMORY:
		"The configuration you chose has less memory than required by the operating system or template you selected.",
	VPS_ERR_8_TOO_MUCH_MEMORY:
		"The configuration you chose has more memory than allowed by the permitted limit.",
	VPS_ERR_9_INSUFFICIENT_STORAGE:
		"The configuration you chose has less storage space than required by the operating system or template you selected.",
	VPS_ERR_10_TOO_MUCH_STORAGE:
		"The configuration you chose has more storage space than allowed by the permitted limit.",
	VPS_ERR_11_PUBLIC_NETWORK_REQUIRED:
		"An internet connection is required when no private network is available.",
	VPS_ERR_12_PRIVATE_NETWORK_EXISTS: "A private network with the name you provided already exists.",
	VPS_ERR_13_DATACENTER_NODES_UNAVAILABLE:
		"It is currently not possible to deploy your VPS in our datacenter. If this problem persists, please contact our support team.",
	VPS_ERR_14_CANNOT_SHRINK_STORAGE:
		"Your VPS cannot be updated because the current disk size is smaller than the required size. It is not possible to shrink the disk.",
	VPS_ERR_15_CANNOT_DOWNGRADE_SNAPSHOTS:
		"Your VPS cannot be updated because you are trying to reduce the number of snapshots while active snapshots still exist. Remove these snapshots before proceeding with the downgrade.",
	VPS_ERR_16_QEMU_ALREADY_RUNNING:
		"The VPS is currently already running. It may take a few seconds to be visible.",
	VPS_ERR_17_QEMU_NOT_RUNNING:
		"The VPS is currently already shut down. It may take a few seconds to be visible.",
	VPS_ERR_18_QEMU_NOT_FOUND: "The VPS was not found.",
	VPS_ERR_19_INVALID_SNAPSHOT_NAME:
		"Invalid snapshot name: A snapshot with the same name already exists.",
	VPS_ERR_20_INSUFFICIENT_SNAPSHOTS:
		"There are not enough snapshots available to deploy a new one. Increase the number of available snapshots for the VPS and try again.",
	VPS_ERR_21_SNAPSHOT_NOT_FOUND:
		"Your snapshot cannot be modified or deleted because it could not be found.",
	VPS_ERR_22_PRIVATE_NETWORK_NOT_FOUND: "The requested private network was not found.",
	VPS_ERR_23_SNAPSHOT_EXPIRATION_DATE_INVALID:
		"An error has occurred while reading the snapshots. Please contact our customer service if this problem persists.",
};

export default error_codes;
